var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"development-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"},[_c('a-icon',{staticStyle:{"font-size":"64px","color":"#fc6732"},attrs:{"type":"info-circle"}})],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('h2',{staticClass:"title"},[_vm._v("待开发中")]),_c('p',{staticClass:"subtitle"},[_vm._v("该功能正在开发中，敬请期待")])])
}]

export { render, staticRenderFns }